import Modal, { Styles } from 'react-modal';

Modal.setAppElement('#modal-portal');

const MODAL_STYLES: Styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)'
  },
  content: {
    width: '17.5%',
    minWidth: '250px',
    borderRadius: '1.25rem',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1000,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none'
  }
};

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  contentLabel: string;
  styles?: Styles;
}

const BubbleModal: React.FC<ModalProps> = ({ isOpen, closeModal, contentLabel, children, styles }) => {
  return (
    <Modal
      isOpen={isOpen}
      style={styles || MODAL_STYLES}
      closeTimeoutMS={100}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
    >
      {children}
    </Modal>
  );
}

export default BubbleModal;
